var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","px-3":"","pt-3":""}},[_c('v-row',{attrs:{"row":"","wrap":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('h3',[_vm._v("Data Verification")]),_c('v-divider')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }